<template>
  <div class="home">
    <div class="login">
      <p>用户登录</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
      >
        <el-form-item label="登录账号" prop="account">
          <el-input v-model="ruleForm.account"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="passwd">
          <el-input
            type="password"
            v-model="ruleForm.passwd"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="记住密码">
          <el-switch v-model="delivery" active-color="dodgerblue"></el-switch>
        </el-form-item>
        <el-button type="primary" @click="login">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";

export default {
  data() {
    return {
      ruleForm: {
        account: "",
        passwd: "",
      },
      delivery: false,
      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        passwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    sessionStorage.removeItem("shopData");
    let status = localStorage.getItem("shopSwit");
    let userName = localStorage.getItem("shopUserName");
    if (status) {
      this.delivery = eval(status.toLowerCase());
      this.ruleForm = JSON.parse(localStorage.getItem("shopUser"));
    }else {
      this.ruleForm.account = userName;
    }
  },
  methods: {
    login() {
      this.$axios
        .post("login", this.ruleForm)
        .then((res) => {
          if (res.code == 0) {
            util.hint(0, "登录成功");
            sessionStorage.setItem("shopData", JSON.stringify(res.data));
            if (this.delivery) {
              localStorage.setItem("shopUser", JSON.stringify(this.ruleForm));
              localStorage.setItem("shopSwit", this.delivery);
            } else {
              localStorage.setItem("ShopUserName", this.ruleForm.userName);
              localStorage.removeItem("shopUser");
              localStorage.removeItem("shopSwit", this.delivery);
            }
            this.$router.push("/index");
          } else {
            util.hint(res.code, res.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
  created() {
    let that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.login(); // 登录方法名
        return false;
      }
    };
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background: url("../assets/loginBg.png") no-repeat;
  background-size: cover;
  font-size: 0.23rem;

  .login {
    width: 5rem;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 70%;
    transform: translate(-10%, -50%);
    padding: 0.1rem 0.5rem 0.5rem;
    box-sizing: border-box;
    border-radius: 0.1rem;

    p {
      text-align: center;
    }

    .el-button {
      width: 100%;
    }
    .el-button--primary {
      background-color: #f39b00;
      border: 1px solid #f39b00;
      color: white;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/login/login.vue